document.addEventListener("click", function (e) {
  const btn = e.target.closest("add-to-cart-component button");
  if (!btn) return;

  // allow theme to finish add-to-cart
  setTimeout(() => {
    window.location.href = "/cart";
  }, 400);
});
